import React, { useEffect, useRef, useState } from 'react'
import {Row, Col, Collapse, Typography,Space, Flex, Card, Spin} from 'antd';
import { PlusOutlined,  } from '@ant-design/icons'
import { motion, useTransform, useScroll } from 'framer-motion';
import './index.css'
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';

const { Title, Text } = Typography;
const { Panel } = Collapse;
    function Faqs() {
        const [currentPanel,setCurrentPanel]=useState(['0'])
        const ref = useRef(null);
        const { scrollYProgress } = useScroll({ container: ref });
        const stickyY = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
        const dispatch = useDispatch()
        const { faqData, loadingfaq }=useSelector(state=>state?.faqsApi)

        useEffect(()=>{
            dispatch(actionsApi.getAllFaq())
        },[])

        return (
            <div className='padding-t-m'>
                <div className='container'>
                    <Card className='faqs' ref={ref}>
                        <Row gutter={[24,32]} justify={'center'}>
                            <Col xl={8} lg={8} md={10} sm={24} xs={24}>
                                <motion.div
                                    style={{
                                    position: 'sticky',
                                    top: 100,
                                    transform: stickyY,
                                    }}>
                                    <Flex vertical gap={20}>
                                        {/* <Flex>
                                            <Text className='text-gray pill-text'>
                                                FAQ's
                                            </Text>
                                        </Flex> */}
                                        <Title level={1} className='m-0 gradient-text'>
                                            Your Questions <br /> Answered
                                        </Title>
                                        <Text className='fs-16'>
                                            Find answers to common questions about Mozeef and our services.
                                        </Text>
                                    </Flex>
                                </motion.div>
                            </Col>
                            <Col xl={16} lg={16} md={14} sm={24} xs={24}>
                                <Space direction='vertical' style={{width:'100%'}} scrollYProgress={scrollYProgress} size={25}>
                                    <Collapse
                                        defaultActiveKey={['0']}
                                        onChange={(keys)=>{setCurrentPanel(keys)}}
                                        ghost
                                    >
                                        {
                                            faqData?.map((faq,f)=>
                                                <Panel className={currentPanel.includes(String(f)) ? 'panel-active panel' : 'panel'}  showArrow={false} header={<Title level={4} className='text-white m-0'>{faq?.title}</Title>} key={f} 
                                                    extra={((currentPanel?.findIndex(x=>x==f))>-1) ?
                                                    <PlusOutlined className='text-white' 
                                                        style={{transform: "rotate(45deg)", transition: 'transform 0.2s ease-in-out', fontSize: 20}} />
                                                    :
                                                    <PlusOutlined className='text-white' 
                                                        style={{transform: "rotate(0deg)", transition: 'transform 0.2s ease-in-out', fontSize: 20}}/>}
                                                        
                                                >
                                                    <div>
                                                        <Text className='text-white fs-16'>
                                                            {faq?.description}
                                                        </Text>
                                                    </div>
                                                </Panel>
                                            )
                                        }
                                    </Collapse>
                                </Space>
                            </Col>
                        </Row>
                        <div className='parent-shap'>
                            <div className='bg-shape'></div>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }

export {Faqs}